module.exports = __webpack_public_path__ + "s5.no1.4861f1d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s5.no1.jpg
// module id = MFnj
// module chunks = 0